import { HttpResponse } from 'rbh-merchant-core';
import { call, put, takeLatest } from 'redux-saga/effects';
import { generalCreators } from '../../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { generalSagas } from '../../../../redux/general/general-saga';
import { GeneralService } from '../../../../redux/general/general-service';
import { mainCreators } from '../../../main-action';
import { reportCreators } from './report-action';
import { EMAIL_VERIFICATION_STATUS, REPORT_REQUEST_ID_LIST, REPORT_TRANSLATION_KEY } from './report-constant';
import { REPORT_ALERT, REPORT_STATE_KEY } from './report-reducer';
import { ReportService } from './report-service';
import { CallConfigAndShopListAction, REPORT_ACTION_TYPE } from './report-type';

function* callConfigAndShopList(action: CallConfigAndShopListAction) {
  const { onSuccess, onFailureCallback } = action.payload;

  yield call(mainCreators.setMainLoading, REPORT_REQUEST_ID_LIST.GET_CONFIG_AND_SHOP_LIST, true);

  const respConfig: HttpResponse = yield call(GeneralService.getGeneralConfigs);
  if (respConfig.success) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.REMOTE_CONFIG, respConfig.data?.appConfigs));
    const respShopList: HttpResponse = yield call(ReportService.getShopList);
    if (respShopList.success) {
      yield put(reportCreators.setReportState(REPORT_STATE_KEY.SHOP_LIST, respShopList.data?.shops));
      yield call(generalSagas.callTnc);
      yield call(onSuccess);
    } else {
      yield call(onFailureCallback);
    }
  } else {
    yield call(onFailureCallback);
  }
  yield call(mainCreators.setMainLoading, REPORT_REQUEST_ID_LIST.GET_CONFIG_AND_SHOP_LIST, false);
}

function* getReportHandler(resp: HttpResponse, callbackParams: { resetReload: () => void, onSuccessChangePage?: () => void, onFailureChangePage?: () => void }) {
  const { resetReload, onSuccessChangePage, onFailureChangePage } = callbackParams;
  if (resp.success) {
    const { result, ...rest } = resp?.data;
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.REPORT_LIST, result));
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.REPORT_RESPONSE, rest));
    if (!!onSuccessChangePage) {
      yield call(onSuccessChangePage);
    }
  } else {
    if (!!onFailureChangePage) {
      yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true,
        onOk: onFailureChangePage,
        clickClosable: false,
        escClosable: false,
        type: MODAL_TYPE.ERROR
      }));
    } else {
      yield put(reportCreators.setReportState(REPORT_STATE_KEY.REPORT_LIST, undefined));
      yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true,
        onOk: resetReload,
        clickClosable: false,
        escClosable: false,
        type: MODAL_TYPE.ERROR
      }));
    }
  }
}

function* getDownloadHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(downLoad, resp);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { callbackParams(); },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function downLoad(resp: HttpResponse) {
  const save = document.createElement('a');
  if (typeof save.download !== 'undefined') {
    save.href = resp.data.url;
    save.target = '_blank';
    save.download = resp.data.url;
    save.dispatchEvent(new MouseEvent('click'));
  }
}

function* verifyEmailHandler(resp: HttpResponse) {
  if (resp.success) {
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.VERIFY_STATUS, EMAIL_VERIFICATION_STATUS.SUCCESS));
  } else if (resp.translationKey === EMAIL_VERIFICATION_STATUS.EXPIRED) {
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.VERIFY_STATUS, EMAIL_VERIFICATION_STATUS.EXPIRED));
  } else if (resp.translationKey === EMAIL_VERIFICATION_STATUS.ALREADY_VERIFIED) {
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.VERIFY_STATUS, EMAIL_VERIFICATION_STATUS.ALREADY_VERIFIED));
  } else {
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.VERIFY_STATUS, EMAIL_VERIFICATION_STATUS.ERROR));
  }
}

function* getConfirmEmailHandler(resp: HttpResponse, callbackParams: { resetReload: () => void }) {
  if (resp.success) {
    const emailVat = [];
    emailVat.push(resp.data.vat);
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.EMAIL_LIST_SHOPS, resp.data.shops as []));
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.EMAIL_LIST_VAT, emailVat as []));
  } else {
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.EMAIL_LIST_SHOPS, undefined));
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.EMAIL_LIST_VAT, undefined));
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { callbackParams.resetReload(); },
      type: MODAL_TYPE.ERROR,
      clickClosable: false,
      escClosable: false
    }));
  }
}

function* postEmailVatAddressHandler(resp: HttpResponse, callbackParams: {
  resetReload: () => void, showSuccess: () => void
}) {
  if (resp.success) {
    yield call(callbackParams.resetReload);
    yield call(callbackParams.showSuccess);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* postEmailShopHandler(resp: HttpResponse, callbackParams: {
  resetReload: () => void, showSuccess: () => void
}) {
  if (resp.success) {
    yield call(callbackParams.resetReload);
    yield call(callbackParams.showSuccess);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* postEmailResendHandler(resp: HttpResponse, callbackParams: {
  popupSuccess: () => void, resetReload: () => void
}) {
  if (resp.success) {
    yield call(callbackParams.popupSuccess);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { callbackParams.resetReload(); },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* patchPickEmailTypeHandler(resp: HttpResponse, callbackParams: { batchError: () => void, alertReportTypeFail: () => void }) {
  if (resp.success) {
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_COUNTDOWN, false));
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_COUNTDOWN, true));
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_STATE, REPORT_ALERT.ALERT_REPORT_TYPE_SUCCESS));
  } else if (resp.statusCode === 1899 && resp.data?.translationKey === REPORT_TRANSLATION_KEY.BATCH_PERIOD_ERROR) {
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_COUNTDOWN, false));
    yield call(callbackParams.batchError);
  } else {
    yield put(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_COUNTDOWN, false));
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { callbackParams.alertReportTypeFail(); },
      type: MODAL_TYPE.ERROR
    }));
  }
}

export const reportSagas = {
  callConfigAndShopList,
  getReportHandler,
  getDownloadHandler,
  downLoad,
  verifyEmailHandler,
  getConfirmEmailHandler,
  postEmailVatAddressHandler,
  postEmailShopHandler,
  postEmailResendHandler,
  patchPickEmailTypeHandler,
  watchers: [
    takeLatest(REPORT_ACTION_TYPE.CALL_CONFIG_AND_SHOP_LIST, callConfigAndShopList)
  ]
};


